// src/components/FacturationTable.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FaPaperPlane } from "react-icons/fa";
import "./facturationTable.css"

function FacturationTable({
  facturations,
  selectedGestionnaires,
  searchRaisonSociale,
  selectedStatut,
  filterBySelectedMonth,
  handleStatusChange,
  handleGeneratePDF,
  sendFactureEmail,
}) {
  return (
    <table className="gestionfacturation_table">
      <thead>
        <tr>
          <th>Raison Sociale</th>
          <th>Gestionnaire</th>
          <th>Bulletin</th>
          <th>STC</th>
          <th>Maladie</th>
          <th>RC</th>
          <th>Contrat</th>
          <th>Licenciement</th>
          <th>Mission excep</th>
          <th>Avenant</th>
          <th>Teulade</th>
          <th>Accès SILAE</th>
          <th>Statut</th>
          <th>Facture PDF</th>
          <th>Envoi Email</th>
          <th>Relance</th> 
        </tr>
      </thead>
      <tbody>
        {facturations
          .filter(
            (f) =>
              (selectedGestionnaires.length === 0 ||
                selectedGestionnaires.map((o) => o.value).includes(f.gestionnaire_nom)) &&
              (searchRaisonSociale === "" ||
                f.raison_sociale.toLowerCase().includes(searchRaisonSociale.toLowerCase()) ||
                f.siret.includes(searchRaisonSociale))
          )
          .filter(filterBySelectedMonth)
          .filter((f) => (selectedStatut ? f.statut === selectedStatut : true))
          .map((f, index) => (
            <tr key={f.id || index}>
              <td>
                <div>{f.raison_sociale}</div>
                <div>{f.siret}</div>
              </td>
              <td>{f.gestionnaire_nom}</td>
              <td>{f.total_bulletin}</td>
              <td>{f.total_stc}</td>
              <td>{f.total_maladie}</td>
              <td>{f.total_RC}</td>
              <td>{f.total_contrat}</td>
              <td>{f.total_licenciement}</td>
              <td>{f.total_mission_excep}</td>
              <td>{f.total_avenant}</td>
              <td>{f.total_teulade}</td>
              <td>{f.total_acces_silae}</td>
              <td>
                <select
                  value={f.statut}
                  onChange={(e) => handleStatusChange(f.id, e)}
                  className={`select-status ${f.statut} select-height `}
                  disabled={f.statut === "Terminé"}
                >
                  <option value="En revue">En revue</option>
                  <option value="A revoir">A revoir</option>
                  <option value="Terminé">Terminé</option>
                </select>
              </td>
              <td>
                <button
                  className="btn-telecharger"
                  onClick={() => handleGeneratePDF(f.siret, f.mois_facturation, f.statut)}
                  disabled={f.statut !== "Terminé"}
                >
                  <FontAwesomeIcon icon={faDownload} size="lg" />
                </button>
              </td>
              <td>
                <button
                  className="btn_envoimail"
                  onClick={() => sendFactureEmail(f.siret, f.mois_facturation)}
                  disabled={f.statut !== "Terminé"}
                  style={{
                    opacity: f.date_envoi_mail ? 1 : 0.4,
                    cursor: f.statut !== "Terminé" ? "not-allowed" : "pointer",
                  }}
                >
                  <FaPaperPlane className="iconmail" size={18} />
                </button>
              </td>
              <td className="cell-relance">
  {Number(f.nb_envoi_facture) > 1 ? (
    <span className="relance-mail">
      {Number(f.nb_envoi_facture) - 1}
    </span>
  ) : (
    <span className="relance-nul">0</span>
  )}
</td>



            </tr>
          ))}
      </tbody>
    </table>
  );
}

export default FacturationTable;
